export const boxPickStatus = {
	ADDED: "added",
	DUPLICATE: "duplicate",
	MOVED: "moved",
};

export const reservedColor = "#23f5501a";
export const reservedForAnotherOrder = "#f530301a";
export const preArrivalPalletColor = "#ff98004d";
